export default __webpack_public_path__ + "static/media/traveler-outside-train-3x.178684a8.webp";